import { DataObject } from '@shared/models/data-object.model';
import { EntityRecordType, EntityType } from '@shared/models/entity-enum';
import { PreprocessorCompanyContacts } from './preprocessor-company-contacts.interface';
import { PreprocessorCompanyContactsGeneral } from './preprocessor-company-contacts-general';
import { PreprocessorCompanyContactsProperty } from './preprocessor-company-contacts-property';

export function processCompanyContacts(entityType: string, record: DataObject): DataObject {
  let preprocessor: PreprocessorCompanyContacts;
  if (entityType === EntityRecordType.Property || entityType === EntityType.Property) {
    preprocessor = new PreprocessorCompanyContactsProperty();
  } else {
    preprocessor = new PreprocessorCompanyContactsGeneral();
  }
  return preprocessor.processCompanyContacts(record);
}
